import {
  successorCustodians,
  beneficiaries,
  grantors,
  trustees
} from './contactTypes'
import C from 'actionTypes/onboarding/routing'

const sectionsList = {
  schwabOnePersonalSection: {
    accountDetails: {
      name: 'Account Details',
      sectionType: C.ONBOARDING_ACCOUNT_DETAILS,
      completeStatusFields: ['reviewedDetails'],
      standardSection: true,
    },
    jointOwner: {
      name: 'Joint Account Holder',
      sectionType: C.ONBOARDING_JOINT_OWNER,
      completeStatusFields: [
        'reviewedJointPersonalInformation',
        'reviewedJointIdentityVerification',
        'reviewedJointEmploymentDetails',
      ],
      standardSection: true,
    },
    successorCustodians: {
      name: 'Successor Custodians',
      sectionType: C.ONBOARDING_CONTACTS_PAGE,
      contactType: successorCustodians.routeType,
      completeStatusFields: ['reviewedSuccessorCustodian'],
      standardSection: true,
    },
    beneficiaries: {
      name: 'Beneficiary',
      sectionType: C.ONBOARDING_CONTACTS_PAGE,
      contactType: beneficiaries.routeType,
      completeStatusFields: ['reviewedBeneficiary'],
      standardSection: true
    },
  },
  schwabIraSection: {
    accountDetails: {
      name: 'Account Details',
      sectionType: C.ONBOARDING_ACCOUNT_DETAILS,
      completeStatusFields: ['reviewedDetails'],
      standardSection: true
    },
    employerInformation: {
      name: 'Employer Information',
      sectionType: C.ONBOARDING_EMPLOYER_INFORMATION,
      completeStatusFields: ['reviewedEmployerDetails'],
      standardSection: false
    },
    additionalDetails: {
      name: 'Additional Details',
      sectionType: C.ONBOARDING_ADDITIONAL_DETAILS,
      completeStatusFields: ['reviewedAdditionalDetails'],
    },
    successorCustodians: {
      name: 'Successor Custodians',
      sectionType: C.ONBOARDING_CONTACTS_PAGE,
      contactType: successorCustodians.routeType,
      completeStatusFields: ['reviewedSuccessorCustodian'],
      standardSection: true,
    },
    beneficiaries: {
      name: 'Beneficiary',
      sectionType: C.ONBOARDING_CONTACTS_PAGE,
      contactType: beneficiaries.routeType,
      completeStatusFields: ['reviewedBeneficiary'],
      standardSection: true
    },
  },
  schwabTrustSection: {
    accountDetails: {
      name: 'Account Details',
      sectionType: C.ONBOARDING_ACCOUNT_DETAILS,
      completeStatusFields: ['reviewedDetails'],
      standardSection: true
    },
    trustees: {
      name: 'Trustee',
      sectionType: C.ONBOARDING_CONTACTS_PAGE,
      contactType: trustees.routeType,
      completeStatusFields: ['reviewedTrustee'],
    },
    grantors: {
      name: 'Grantor',
      sectionType: C.ONBOARDING_CONTACTS_PAGE,
      contactType: grantors.routeType,
      completeStatusFields: ['reviewedGrantor'],
    },
  },
  schwabCharitableSection: {
    accountDetails: {
      name: 'Account Details',
      sectionType: C.ONBOARDING_ACCOUNT_DETAILS,
      completeStatusFields: ['reviewedDetails'],
      standardSection: true,
    },
    beneficiaries: {
      name: 'Beneficiary',
      beneficiarySubType: 'Successor Donor',
      sectionType: C.ONBOARDING_CONTACTS_PAGE,
      contactType: beneficiaries.routeType,
      completeStatusFields: ['reviewedBeneficiary'],
      standardSection: true
    },
  },
}
export default sectionsList



// WEBPACK FOOTER //
// ./src/utils/sectionsList.js